module.exports = __webpack_public_path__ + "img/symbol_9.fba98b48.png";